module.exports = __webpack_public_path__ + "static/media/python.53460988.png";